import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-close-button',
  templateUrl: './close-button.component.html',
  styles: []
})
export class CloseButtonComponent implements OnInit {

  @Input() width = 'w-4';
  @Input() height = 'h-4';

  @Output() close = new EventEmitter();

  isHovered = false;

  constructor() { }

  ngOnInit(): void {
  }

  onHover(isHoverd: boolean) {
    this.isHovered = isHoverd;
  }

  onClick() {
    this.close.emit();
  }

  getClass(): string {
    const hoveredClass = this.isHovered ? 'tk-i-close-blue' : 'tk-i-close';
    return `${this.width} ${this.height} ${hoveredClass}`;
  }

}
